/* eslint-disable */
import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import {Box, Theme, Tooltip} from '@mui/material';
import { useTranslation } from "react-i18next";
import {makeStyles} from "@mui/styles";

interface CustomDeleteDialogProps {
  id: number;
  text: string;
  name: string;
  callback: any;
  actionEvent: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    id: number,
  ) => void;
}

const useStyles = makeStyles((theme?: Theme) => ({
  component: {
    cursor: "pointer"
  }
}));

const DeleteDialog = (props: CustomDeleteDialogProps): any => {
  // traducciones
  const [t] = useTranslation();
  const { id, text, name, actionEvent } = props;
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const classes = useStyles();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = (event: React.MouseEvent<HTMLButtonElement>) => {
    setLoading(true)
    if (actionEvent)
      actionEvent(event, id);
    setOpen(false);
  };

  return (
    <>

        {/*<Tooltip
          title={t("common.delete_record")}
          placement={"top"}
        >*/}
      <div className={classes.component} onClick={() => handleClickOpen()}>
          <IconButton sx={{ color: 'error.main' }}>
            <Tooltip
                title={t("common.delete_record")}
                placement={"bottom"}
            >
              <DeleteIcon />
            </Tooltip>
          </IconButton>
        {/*</Tooltip>*/}
      </div>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          Confirmación
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {
              (text) ?
                <>
                  {`¿${text} ${name}?`}
                </>
                :
                <>
                  ¿Esta seguro que desea eliminar el registro seleccionado?
                </>
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} autoFocus onClick={handleClose}>
            Cancelar
          </Button>
          <Button disabled={loading} onClick={handleDelete} autoFocus>
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DeleteDialog;